require('../../../modules/es.array.find-index');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').findIndex;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/find-index.js
// module id = 974
// module chunks = 0